module.exports = __webpack_public_path__ + "static/img/eec-group6.b674d9f1.png";